<template>
  <div>
    <v-dialog v-model="createCampaignDialog" width="500">
      <v-card class="border-radius-standard">
        <v-card-title class="headline" primary-title style="font-size: 28px">
          Rename Campaign
          <v-spacer />
          <v-icon @click="createCampaignDialog = false">close</v-icon>
        </v-card-title>
        <v-card-text>
          <add-campaign
            ref="addCampaign"
            :put="campaign"
            @loading="addButtonLoader = $event"
            @success="handleAddCampaign"
          >
            <label
              slot="before-name"
              class="black--text"
              style="font-size: 16px"
              >Campaign Name</label
            >
          </add-campaign>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn outline @click="createCampaignDialog = false"> Cancel </v-btn>
          <v-btn
            :loading="addButtonLoader"
            color="primary"
            @click="addNewCampaign"
          >
            Rename
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-layout
      row
      wrap
      class="border-radius-standard px-0 py-0 align-center"
      align="center"
    >
      <v-flex v-if="campaign">
        <span class="template-title"
          >{{ campaign.name }}

          <v-icon
            v-if="campaign && campaign.status === 'DRAFT'"
            @click="createCampaignDialog = true"
            color="primary"
            >edit</v-icon
          >
        </span>
        <span :class="setTextColor" style="font-weight: bold"
          >({{ campaign.status }})</span
        >
      </v-flex>
      <v-spacer />
      <v-spacer />

      <v-btn
        color="black"
        @click="save"
        outline
        v-if="campaign && campaign.status === 'DRAFT'"
        :disabled="
          campaign &&
          (campaign.status === 'SCHEDULED' || campaign.status === 'CANCELED')
        "
        >Save for later</v-btn
      >
      <v-btn
        color="primary"
        @click="send"
        v-if="campaign && campaign.status === 'DRAFT'"
        :disabled="
          campaign &&
          (campaign.status === 'SCHEDULED' || campaign.status === 'CANCELED')
        "
        >Send Now</v-btn
      >

      <schedule-campaign
        v-if="campaign"
        :campaign="campaign"
        @success="getCampaignData"
        @updated="getCampaignData"
      />
    </v-layout>
    <v-layout row wrap class="white border-radius-standard pl-3 py-3">
      <v-flex xs12 lg6 class="px-0 template-msg-editor">
        <v-flex xs12>
          <div class="title-icon">
            <span
              class="botter-image1-icon white--text text-lg-2 icon-holder primary"
            />
            <span class="title-content">Template Message</span>
          </div>
        </v-flex>
        <v-flex xs12>
          <v-select
            v-model="input.templateId"
            :items="templateMessagesOptions"
            class="field-width"
            item-text="text"
            item-value="value"
            @change="save"
            outlined
          />
        </v-flex>

        <template-editor
          v-if="input.templateId"
          v-model="componentsValue"
          ref="templateEditorRef"
          :template-id="input.templateId"
          disable
          show-only
          @info="handleTemplateData"
        >
          <span slot="title" />
          <v-flex xs12 slot="header-append">
            <div v-if="input.image">
              <label>Image link</label>
              <v-text-field
                placeholder="Image Url"
                class="field-width"
                outline
                v-model="input.image.value"
              />
              <label> Upload Your Image </label>
              <image-input
                :url="input.image.value"
                class="field-width"
                @onUploadComplete="input.image.value = $event[0].url"
                @onFileRemove="input.image.value = ''"
                types="image/png, image/jpg, image/jpeg"
                icon="botter-image-icon"
              />
            </div>

            <div v-if="input.document">
              <label>Document link</label>
              <v-text-field
                placeholder="File URL"
                outline
                class="field-width"
                v-model="input.document.value"
              />
              <label> Upload Your Document </label>
              <image-input
                :url="input.document.value"
                type=""
                icon="botter-logo-icon"
                class="field-width"
                @onUploadComplete="input.document.value = $event[0].url"
                @onFileRemove="input.document.value = ''"
                types="application/pdf, application/docx, application/doc"
              >
                <v-icon slot="icon">content_paste</v-icon>
              </image-input>
            </div>

            <p v-if="input.header.length">Header Parameters</p>
            <div
              v-for="(variable, v) in input.header"
              :key="variable.attribute"
            >
              <label class="grey--text"
                >Value {{ variable.attribute.split("header_").join("") }}</label
              >
              <v-text-field
                :value="variable.value"
                @input="handleInputChange('header', v, $event, variable)"
                placeholder="Header"
                class="field-width"
                outline
              />
            </div>
            <p v-if="input.body.length">Body Parameters</p>
            <div v-for="(variable, v) in input.body" :key="variable.attribute">
              <label class="grey--text"
                >Value {{ variable.attribute.split("body_").join("") }}</label
              >
              <v-text-field
                placeholder="Body"
                class="field-width"
                @input="handleInputChange('body', v, $event, variable)"
                :value="variable.value"
                outline
              />
            </div>
            <p v-if="input.footer.length">Footer Parameters</p>
            <div
              v-for="(variable, v) in input.footer"
              :key="variable.attribute"
            >
              <label class="grey--text"
                >Value {{ variable.attribute.split("footer_").join("") }}</label
              >
              <v-text-field
                :value="variable.value"
                @input="handleInputChange('footer', v, $event, variable)"
                placeholder="Footer"
                class="field-width"
                outline
              />
            </div>
            <p v-if="input.buttons.length">Buttons Parameters</p>
            <div
              v-for="(variable, v) in input.buttons"
              :key="variable.attribute"
            >
              <label class="grey--text">Value {{ variable.attribute }}</label>
              <v-text-field
                :value="variable.value"
                @input="handleInputChange('buttons', v, $event, variable)"
                :placeholder="variable.attribute"
                class="field-width"
                outline
              />
            </div>

            <div v-if="!uploadEnabled && uploadStatus" class="mt-3">
              <label>Upload Your Data</label>
              <uploading-status
                :status="uploadStatus.status"
                :message="uploadStatus.message"
                class="field-width"
                @download-file="downloadTemplate"
                @update-file="uploadAttemp = true"
                @upload-virtual-complete="handleVirtaulSuccess"
              />
            </div>
            <div class="mt-3">
              <!-- <label >Your Receivers File URL</label>
            <v-text-field 
              placeholder = "File URL" 
              outline
              class="field-width"
              v-model="receivers.url"
               /> -->
              <label v-if="uploadEnabled"> Upload Your Data </label>
              <div v-if="loaders.uploadStatus && uploadEnabled" class="mt-3">
                <uploading-status
                  status="inProgress"
                  class="field-width"
                  @download-file="downloadTemplate"
                  @upload-virtual-complete="handleVirtaulSuccess"
                  @update-file="uploadAttemp = true"
                />
              </div>
              <image-input
                v-if="uploadEnabled"
                :style="{ display: loaders.uploadStatus ? 'hidden' : 'block' }"
                :url="receivers.url"
                :upload-instance="$http_session_manager"
                :upload-url="`/campaigns/${campaign._id}/upload-receivers-template`"
                :drag-placeholder="null"
                type=".csv, application/vnd.ms-excel, *"
                :icon="null"
                :validation="false"
                class="field-width receivers-uploader"
                @onUploadComplete="handleReceiversUploadSuccess"
                @error="handleUploadFailure"
              >
                <div
                  slot="placeholder"
                  class="px-2 primary--text"
                  style="text-align: left; display: flex; align-items: center"
                >
                  <span class="botter-excel-icon" style="font-size: 32px" />
                  <span class="px-2"
                    >To customize data based on user, drag your file here</span
                  >
                </div>
              </image-input>
              <a
                v-if="uploadEnabled"
                color="primary"
                style="text-decoration: underline; font-size: 12px"
                class="pa-0 ma-0 download-template-text"
                flat
                @click="downloadTemplate"
              >
                <b>Download File Template</b>
              </a>
            </div>
          </v-flex>
        </template-editor>
      </v-flex>

      <v-flex v-if="!loaders.campaign" xs12 lg6 class="py-5">
        <v-layout row wrap justify-center align="center">
          <v-flex xs12 style="display: flex; justify-content: center">
            <template-viewer
              :loading="!loaders.campaign"
              :init="appliedVariables"
              @components-format="formatCompnentsInput"
              :params="input"
              :disabled="!input.templateId || !input.templateId.length"
            />
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <receivers-crud v-if="currentCampaign" ref="receiversRef" />
  </div>
</template>

<script>
import imageInput from "@/components/block-build/blocks/block-cards/common-inner-blocks/image-uploader-dropzone";
import AddCampaign from "@/components/campaign-manager/campaigns-crud/AddCampaign.vue";
import ScheduleCampaign from "@/components/campaign-manager/campaigns-crud/ScheduleCampaign";
import UploadingStatus from "@/components/campaign-manager/campaigns-crud/UploadingStatus";
import ReceiversCrud from "@/components/campaign-manager/receivers-crud";
import TemplateEditor from "@/components/campaign-manager/template-message-editor/TemplateEditor";
import TemplateViewer from "@/components/campaign-manager/template-message-editor/TemplateViewer";
import fileDownload from "js-file-download";
export default {
  name: "SingleCampaing",
  components: {
    TemplateViewer,
    TemplateEditor,
    imageInput,
    ReceiversCrud,
    ScheduleCampaign,
    UploadingStatus,
    AddCampaign,
  },
  data() {
    return {
      campaign: null,
      templateData: null,
      componentsValue: [],
      uploadStatus: null,
      uploadAttemp: false,
      loaders: {
        campaign: false,
        uploadStatus: false,
      },

      receivers: {
        url: "",
        users: null,
      },
      formattedComponents: {},
      input: {
        templateId: null,
        campaign: false,
        header: [],
        body: [],
        footer: [],
        image: null,
        document: null,
        url: [],
        phoneNumber: [],
        buttons: [],
      },
      paramtersInput: [],
      addButtonLoader: false,
      createCampaignDialog: false,
    };
  },
  async mounted() {
    await this.getTemplateMessages();
    await this.getCampaignData();
    await this.getReceivers();
    await this.checkUploadStatus();
  },
  computed: {
    setTextColor() {
      let classes = [];
      if (this.campaign) {
        let status = this.campaign.status.toLowerCase();

        switch (status) {
          case "draft":
            classes.push("purple--text");
            break;
          case "sent":
            classes.push("green--text");
            break;
          case "paused":
            classes.push("amber--text");
            break;
          case "canceled":
            classes.push("red--text");
            break;
          case "deleted":
            classes.push("red--text");
            break;
          case "scheduled":
            classes.push("amber--text");
            break;
        }
        return classes;
      }
      return [];
    },
    currentCampaign() {
      return this.$store.state.campaigns.selectedCampaign;
    },
    uploadEnabled() {
      return (
        !this.loaders.uploadStatus &&
        (this.uploadAttemp ||
          !this.uploadStatus ||
          this.uploadStatus.status === "Not-Uploaded-Yet")
      );
    },
    editedParams() {
      return Object.values(this.$_.pickBy(this.input, (i) => i))
        .filter((p) => {
          if (Array.isArray(p)) {
            return Boolean(p.length);
          } else return p.constructor === Object;
        })
        .flat();
    },
    templateMessagesOptions() {
      if (!this.campaign) return [];
      return this.$store.state.campaigns.templateMessages
        .filter((t) => {
          let status;

          if (Array.isArray(t.status)) {
            status = t.status[0].value;
          } else {
            status = t.status;
          }

          t.status = status;
          return (
            status === "APPROVED" &&
            (t.app.id === this.campaign.app.app_id ||
              t.app.whatsapp_business_account_id ===
                this.campaign.app.whatsapp_business_account_id)
          );
        })
        .map((t) => ({ text: `${t.name} (${t.status})`, value: t._id }));
    },
    appliedVariables() {
      if (!this.componentsValue || !this.componentsValue.length) {
        return [];
      }
      let result = this.$_.cloneDeep(this.componentsValue);
      // header
      const headerIndex = result.findIndex((i) => i.type === "HEADER");
      if (headerIndex !== -1) {
        // text
        if (result[headerIndex].format === "TEXT") {
          result[headerIndex].text = result[headerIndex].text
            .split(" ")
            .map((i) => {
              if (!new RegExp(/{{\w}}/).test(i)) return i;
              let slugIndex = this.input.header.findIndex(
                (h) => h.attribute === `header_${i}`
              );
              if (
                slugIndex !== -1 &&
                this.input.header[slugIndex].value.length
              ) {
                return this.input.header[slugIndex].value;
              }
              return i;
            })
            .join(" ");
        }

        if (result[headerIndex].format === "IMAGE") {
          result[headerIndex].url = this.input.image
            ? this.input.image.value
            : "";
        }
        if (result[headerIndex].format === "DOCUMET") {
          result[headerIndex].url = this.input.document
            ? this.input.document.value
            : "";
        }
      }

      // body
      const bodyIndex = result.findIndex((i) => i.type === "BODY");
      if (bodyIndex !== -1) {
        // text

        result[bodyIndex].text = result[bodyIndex].text
          .split(" ")
          .map((i) => {
            if (!new RegExp(/{{\w}}/).test(i)) return i;
            let slugIndex = this.input.body.findIndex(
              (h) => h.attribute === `body_${i}`
            );
            if (slugIndex !== -1 && this.input.body[slugIndex].value.length) {
              return this.input.body[slugIndex].value;
            }
            return i;
          })
          .join(" ");
      }

      // footer
      const footerIndex = result.findIndex((i) => i.type === "FOOTER");
      if (footerIndex !== -1) {
        // text

        result[footerIndex].text = result[footerIndex].text
          .split(" ")
          .map((i) => {
            if (!new RegExp(/{{\w}}/).test(i)) return i;
            let slugIndex = this.input.footer.findIndex(
              (h) => h.attribute === `footer_${i}`
            );
            if (slugIndex !== -1 && this.input.footer[slugIndex].value.length) {
              return this.input.footer[slugIndex].value;
            }
            return i;
          })
          .join(" ");
      }

      return result;
    },
  },
  methods: {
    handleUploadFailure() {
      this.loaders.uploadStatus = false;
      this.uploadStatus = { status: "Failed" };
    },
    handleInputChange(context, attr, event, val) {
      // console.log(event, attr, context)
      this.$set(this.input[context], attr, { ...val, value: event });
    },
    addNewCampaign() {
      if (this.$refs.addCampaign) this.$refs.addCampaign.submit();
    },
    handleAddCampaign() {
      this.createCampaignDialog = false;
    },
    formatCompnentsInput(e) {
      this.formattedComponents = e;
    },
    getTextVariables(text) {
      return text.split(" ").filter((i) => new RegExp(/{{\w}}/).test(i));
    },
    getKeyVariables(key) {
      const result = {};
      if (key === "header") {
        if (
          this.formattedComponents.header &&
          this.formattedComponents.header.text
        ) {
          const textVariables = this.getTextVariables(
            this.formattedComponents.header.text
          );
          let i;
          for (i = 0; i < textVariables.length; i += 1) {
            result[textVariables[i]] = "";
          }
        }
      } else if (key === "body") {
        if (
          this.formattedComponents.body &&
          this.formattedComponents.body.text
        ) {
          const textVariables = this.getTextVariables(
            this.formattedComponents.body.text
          );
          let i;
          for (i = 0; i < textVariables.length; i += 1) {
            result[textVariables[i]] = "";
          }
        }
      } else if (key === "footer") {
        if (
          this.formattedComponents.footer &&
          this.formattedComponents.footer.text
        ) {
          const textVariables = this.getTextVariables(
            this.formattedComponents.footer.text
          );
          let i;
          for (i = 0; i < textVariables.length; i += 1) {
            result[textVariables[i]] = "";
          }
        }
      }
      return result;
    },
    async getTemplateMessages() {
      await this.$store.dispatch("templatemessages/get", null);
      await this.$store.dispatch("templatesettings/get", null);
    },
    mixParams(template, campaign) {
      let i;
      let index;
      const params = [];
      for (i = 0; i < template.length; i += 1) {
        index = campaign.findIndex(
          (row) => template[i].attribute === row.attribute && row.value.length
        );
        if (index !== -1) {
          params.push(campaign[index]);
        } else {
          params.push(template[i]);
        }
      }
      return params;
    },
    handleTemplateData(e) {
      if (!e) return;
      this.templateData = e;
      const params = this.mixParams(e.parameters, this.campaign.parameters);
      this.paramtersInput = this.$_.cloneDeep(params);
      this.input.image = this.paramtersInput.filter(
        (p) => p.attribute === "image"
      ).length
        ? this.paramtersInput.filter((p) => p.attribute === "image")[0]
        : null;
      this.input.document = this.paramtersInput.filter(
        (p) => p.attribute === "document"
      ).length
        ? this.paramtersInput.filter((p) => p.attribute === "document")[0]
        : null;
      this.input.header = this.paramtersInput.filter((p) =>
        p.attribute.startsWith("header_")
      );
      this.input.body = this.paramtersInput.filter((p) =>
        p.attribute.startsWith("body_")
      );
      this.input.footer = this.paramtersInput.filter((p) =>
        p.attribute.startsWith("footer_")
      );
      this.input.buttons = this.paramtersInput.filter((p) =>
        p.attribute.startsWith("url_")
      );
    },
    async getCampaignData() {
      const response = await this.$http_session_manager.get(
        `/campaigns/${this.$route.params.id}`
      );
      this.campaign = response.data;
      if (
        ["DRAFT", "CANCELED", "SCHEDULED"].indexOf(this.campaign.status) === -1
      ) {
        this.$router.push(`/campaigns/${this.campaign._id}/overview`);

        return;
      }
      this.$store.commit("campaigns/select", response.data);

      if (response.data.message) {
        this.input.templateId = response.data.message.template_msg_id;
        this.handleTemplateData();
      }
    },
    async getReceivers() {
      if (this.$refs.receiversRef) this.$refs.receiversRef.getReceivers(false);
    },
    async save() {
      try {
        this.loaders.campaign = true;
        await this.saveTemplateMessage();
        await this.saveParams();
        await this.getCampaignData();
        this.loaders.campaign = false;
      } catch (err) {
        this.loaders.campaign = false;
        throw err;
      }
    },
    async send() {
      await this.sendCampaign();

      this.$router.push("/campaigns/all");
    },
    async sendCampaign() {
      await this.$http_session_manager.post(
        `/campaigns/${this.$route.params.id}/send`
      );
      return true;
    },
    async saveTemplateMessage() {
      await this.$http_session_manager.put(
        `/campaigns/${this.$route.params.id}/message`,
        {
          type: "template",
          template_msg_id: this.input.templateId,
        }
      );
      return true;
    },
    async saveParams() {
      await this.$http_session_manager.put(
        `/campaigns/${this.$route.params.id}/parameters`,
        { parameters: this.editedParams }
      );
      return true;
    },

    async handleReceiversUploadSuccess(e) {
      this.receivers.url = e;
      this.uploadAttemp = false;
      this.uploadStatus = { status: "Inprogress" };
      await this.checkUploadStatus();
      await this.getReceivers();
    },
    async downloadTemplate() {
      const response = await this.$http_session_manager.get(
        `/campaigns/${this.$route.params.id}/download-receivers-template`
      );

      fileDownload(response, "template.csv");
      this.uploadAttemp = true;
    },
    async checkUploadStatus() {
      // handle Virtual Success
      if (this.uploadStatus && this.uploadStatus.status === "Virtual") {
        this.uploadStatus.status = "Success";
        return;
      }
      try {
        const status = await this.getUploadStatus();
        if (
          status &&
          status.status !== "Success" &&
          status.status !== "Not-Uploaded-Yet" &&
          status.status !== "Failed"
        ) {
          setTimeout(async () => {
            await this.checkUploadStatus();
          }, 10000);
          if (status.status === "Inprogress") {
            this.uploadStatus = status;
          }
        } else {
          this.uploadStatus = status;
          await this.getReceivers();
        }
      } catch (err) {
        this.loaders.uploadStatus = false;
        this.uploadStatus = { status: "Failed" };
        throw err;
      }
    },
    handleVirtaulSuccess() {
      this.uploadStatus.status = "Virtual";
      this.uploadAttemp = true;
    },
    async getUploadStatus() {
      try {
        this.loaders.uploadStatus = true;
        const response = await this.$http_session_manager.get(
          `/campaigns/${this.$route.params.id}/uploading-status`
        );

        this.loaders.uploadStatus = false;
        return response.data;
      } catch (err) {
        this.loaders.uploadStatus = false;
        this.uploadStatus = { status: "Failed" };

        throw err;
      }
    },
  },
};
</script>

<style lang="scss">
.header-col {
}
.receivers-uploader > .image-uploader {
  max-width: 100%;
  height: 100px;
  position: relative;
  border: 2px dashed #ccc;
  border-radius: 8px;
  background-color: #f4f5f9;
  overflow: hidden;
}
.header-option {
  width: 100px;
  height: 100px;
  padding: 3px;
  border-radius: 8px;
  border: 1px dashed #ccc;
  background-color: #f4f5f9;
  display: block;
}
.header-content {
  width: 100px;
  margin-left: -3px;
}
.title-icon {
  .icon-holder {
    border-radius: 8px;
    padding: 3px;
  }
  .title-content {
    padding-left: 5px;
    vertical-align: super;
    font-size: 16px;
  }
}
.template-subtitle {
  font-size: 16px;
  font-weight: bold;
  padding-top: 4px;
}
.button-option {
  border: 1px solid #372fac;
  border-radius: 8px;
  padding: 10px 5px;
  width: 30%;
  justify-content: center;
  cursor: pointer;
  margin-left: 0px;
  margin-right: 4px;
}
.buttons-radio-gp {
  .v-input__control {
    width: 100%;
  }
}
.field-width {
  width: 450px;
}
.template-msg-editor {
  border-right: 2px dashed #f4f5f9;
}
.template-title {
  font-weight: bold;
  font-size: 22px;
}
.download-template-text:hover {
  background-color: white !important;
}
</style>
